import React from "react";
import { useAccount } from "wagmi";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import { trimAddress } from "../helper/functions";
import { WalletIcon } from "../assets/icons/index";

export const Connect = function () {
  const { address, isConnected } = useAccount();
  const { open } = useWeb3Modal();

  return (
    <React.Fragment>
      <>
        {address && isConnected ? (
          <button className="btn btn-primary" onClick={() => open()}>
            <i class="fa-solid fa-wallet mx-2"></i>
            {trimAddress(address)}
          </button>
        ) : (
          <button className="btn btn-primary d-flex align-items-center" onClick={() => open()}>
            {/* <i class="fa-solid fa-wallet mx-2"></i> */}
            Connect wallet
            <WalletIcon className="mx-2" />
          </button>
        )}
      </>
    </React.Fragment>
  );
};

export default Connect;
